/* CancelEscButton.tsx generated by @compiled/babel-plugin v0.36.1 */
/* eslint-disable @atlaskit/design-system/no-unsafe-style-overrides */
import "./CancelEscButton.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { useIntl } from 'react-intl-next';
import Button from '@atlaskit/button/new';
import messages from './messages';
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
var escTextStylesUnbounded = null;

// no tokens for 3px exist, so using raw values
var escTextStyles = null;
export var CancelEscButton = function CancelEscButton(_ref) {
  var onCancel = _ref.onCancel,
    autoFocus = _ref.autoFocus;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  return /*#__PURE__*/React.createElement(Button, {
    autoFocus: autoFocus,
    testId: "cancel-esc-button",
    type: "button",
    onClick: onCancel
  }, formatMessage(messages.labelCancel), /*#__PURE__*/React.createElement("span", {
    className: ax(["_2rkoiti9 _syaz1gjq _bfhkm7j4 _k48pi7a9", "_ca0q1l7b _u5f31l7b _n3td1l7b _19bv1l7b _18u014y2"])
  }, formatMessage(messages.labelEsc)));
};